// src/components/FloatingButtons/FloatingButtons.jsx
import React from 'react';
import { FiPhoneCall } from 'react-icons/fi';
import { FaWhatsapp } from 'react-icons/fa';
import './FloatingButtons.css';

function FloatingButtons() {
  // Avukatın telefon numarası ve WhatsApp linki (İstediğin zaman güncelleyebilirsin)
  const phoneNumber = "+905510791959"; // Buraya gerçek numarayı yazabilirsin kanka
  const whatsappMessage = "Merhaba Av. Emre Bey, hukuki danışmanlık hakkında bilgi almak istiyorum.";
  const whatsappUrl = `https://wa.me/${phoneNumber.replace('+', '')}?text=${encodeURIComponent(whatsappMessage)}`;

  return (
    <div className="floating-buttons-container">
      {/* Sol Alt: Telefon Arama Butonu */}
      <a 
        href={`tel:${phoneNumber}`} 
        className="floating-btn phone-btn"
        aria-label="Telefon ile Ara"
      >
        <FiPhoneCall className="floating-icon" />
        <span className="tooltip-text">Hemen Ara</span>
      </a>

      {/* Sağ Alt: WhatsApp Destek Butonu */}
      <a 
        href={whatsappUrl} 
        target="_blank" 
        rel="noopener noreferrer" 
        className="floating-btn whatsapp-btn"
        aria-label="WhatsApp ile İletişime Geç"
      >
        <FaWhatsapp className="floating-icon" />
        <span className="tooltip-text">WhatsApp Destek</span>
      </a>
    </div>
  );
}

export default FloatingButtons;